/* src/app/payroll/employee-payroll-item/employee-payroll-item-presenter/employee-payroll-item-presenter.component.scss */
body#themeTag :host ::ng-deep .p-inline-message {
  margin-top: 1em;
  margin-bottom: 1em;
}
.save-pending-banner {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  margin-bottom: 0.75rem;
  margin-top: 0.75rem;
  background: var(--p-primary-50, #f0f9ff);
  border: 1px solid var(--p-primary-200, #bae6fd);
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.save-pending-banner__content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  width: 100%;
}
.save-pending-banner__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--p-primary-600, #0284c7);
  font-size: 1.25rem;
  flex-shrink: 0;
}
.save-pending-banner__message {
  flex: 1;
  min-width: 200px;
  font-size: 0.9375rem;
  color: var(--p-text-color, #374151);
  line-height: 1.4;
}
.save-pending-banner__action {
  flex-shrink: 0;
}
.header-label {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}
:host-context(html.app-dark) .save-pending-banner,
:host-context(body.dark-theme) .save-pending-banner {
  background: var(--p-primary-color-dark, rgba(9, 50, 73, 0.6901960784));
  border-color: var(--p-primary-700, #174158);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
:host-context(html.app-dark) .save-pending-banner__icon,
:host-context(body.dark-theme) .save-pending-banner__icon {
  color: var(--p-primary-300, #7dd3fc);
}
:host-context(html.app-dark) .save-pending-banner__message,
:host-context(body.dark-theme) .save-pending-banner__message {
  color: var(--p-primary-100, #e0f2fe);
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  vertical-align: middle;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr {
  min-height: 2.35rem;
}
.edit-cell {
  min-height: 2.35rem;
  box-sizing: border-box;
}
.edit-cell .edit-cell__actions {
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-height: 2.35rem;
  box-sizing: border-box;
}
.edit-cell .edit-cell__actions > button {
  height: 1.9rem !important;
  width: 1.9rem !important;
  flex-shrink: 0;
}
/*# sourceMappingURL=employee-payroll-item-presenter.component.css.map */
